export default "__VITE_ASSET__SqG8yN52__"